import {
  FETCH_ARCHIVED_STUDIES_REQUEST,
  FETCH_ARCHIVED_STUDIES_SUCCEEDED,
  FETCH_ARCHIVED_STUDIES_FAILED
} from '../actions/archivedStudyActions'
import { CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED } from '../actions/unarchiveStudyRequestActions'

const initialState = {
  items: [],
  page: 1,
  totalPages: 0,
  isLoading: true,
  query: '',
  order: 'desc',
  sort: 'date'
}

const archivedStudies = (state = initialState, action) => {
  const { response } = action
  switch (action.type) {
    case FETCH_ARCHIVED_STUDIES_REQUEST:
      return {
        ...state,
        isLoading: true,
        page: action.page || 1,
        query: action.query || ''
      }
    case FETCH_ARCHIVED_STUDIES_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        totalPages: response.meta.totalPages,
        sort: response.meta.sort,
        order: response.meta.order,
        items: response.archivedStudies
      }
    case FETCH_ARCHIVED_STUDIES_FAILED:
      return { ...state, isLoading: false }
    case CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED:
      return {
        ...state,
        items: state.items.map(archivedStudy => {
          if (
            archivedStudy.id !== response.unarchiveStudyRequest.archivedStudyId
          ) {
            return archivedStudy
          }
          return { ...archivedStudy, unarchivingStatus: 'new' }
        })
      }
    default:
      return state
  }
}

export default archivedStudies



// WEBPACK FOOTER //
// ../src/reducers/archivedStudies.js